'use client';

import { useRouter } from 'next-nprogress-bar';
import { Button, type ButtonProps } from 'ui';

type MDXCallToActionProps = ButtonProps & {
  href: string;
};

export function MDXCallToAction({ href, ...props }: MDXCallToActionProps) {
  const router = useRouter();
  return <Button {...props} onClick={() => router.push(href)} />;
}
